import { render, staticRenderFns } from "./SupplierConnection.vue?vue&type=template&id=405066f2"
import script from "./SupplierConnection.vue?vue&type=script&lang=js"
export * from "./SupplierConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports